module.exports = __webpack_public_path__ + "img/m_banner03_gearingupthetrade-e.97f37a4d.jpg";